
export const IsNotOwner = "0";
